import Logger, {LOG_LEVELS} from '../utils/logger';
import _ from 'lodash';

export const MODULE_NAME = 'GLOBAL_FILTER_CONTROLLER';
const log = new Logger(MODULE_NAME, LOG_LEVELS.DEBUG);
const GLOBAL_FILTER_SETTING = 'GLOBAL_FILTER_SETTING';


function getSettingKey() {
    const ID = window.auiUser && Object.keys(window.auiUser).length === 0 ? localStorage.uuid : window?.auiUser?.subjectId;
    if (!ID) return undefined;
    // Scope by MVR tenant (?customerId=) so a company saved for one tenant is never replayed against another (VRS-2413).
    const mvrCustomerId = localStorage.mvrCustomerId;
    return mvrCustomerId ? `${ID}_mvr${mvrCustomerId}_${GLOBAL_FILTER_SETTING}` : `${ID}_${GLOBAL_FILTER_SETTING}`;
}

function getUserSetting() {
    const key = getSettingKey();

    if(!key) return;
    const settingStr = localStorage[key] || '{}';
    try {
        return JSON.parse(settingStr);
    } catch(e) {
        log.debug('Error while parsing json: ', e);
        return;
    }
}

function putUserSetting(settingObj) {
    try {
        const key = getSettingKey();
        if(!key) return;
        const settingStr = JSON.stringify(settingObj);
        localStorage[key] = settingStr;
    } catch(e) {
        log.debug('Error: ', e);
    }
}

export const API = {
    get: function(key) {
        log.debug('get() - key: ', key);
        let settingObj = getUserSetting();
        return settingObj ? settingObj[key] : undefined;
    },
    getAll: function() {
        log.debug('getAll()');
        return getUserSetting();
    },
    fieldUpdate: function(key, value) {
        log.debug('fieldUpdate() key: %s, value: %s', key, value);
        if(key) {
            const settingObj = getUserSetting();
            settingObj[key] = value;
            putUserSetting(settingObj);
        }
        return getUserSetting();
    },
    bulkChange: function(value) {
        log.debug('bulkChange() value', value);
        putUserSetting(value);
    },
    /**
     * Additive counterpart to bulkChange(): merges `partial` into the stored settings instead of
     * replacing them wholesale. Callers that only own a few of the global filter keys must use this,
     * otherwise they silently wipe the keys other pages rely on (countryCode, filingType, returnType...).
     *
     * @param partial keys to write
     * @param removeKeys keys to drop from the stored settings
     */
    merge: function(partial = {}, removeKeys = []) {
        log.debug('merge() partial: %s, removeKeys: %s', partial, removeKeys);
        const next = Object.assign({}, getUserSetting() || {}, partial);
        (Array.isArray(removeKeys) ? removeKeys : []).forEach((key) => delete next[key]);
        Object.keys(next).forEach((key) => {
            if (next[key] === undefined) {
                delete next[key];
            }
        });
        putUserSetting(next);
        return getUserSetting();
    }
};

export default API;
